var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#aa-video-ad-unit .playPauseContainer {\n  display: block; \n  position: absolute; \n  width: 100%; \n  height: 100%; \n  z-index: 3;\n}\n\n#aa-video-ad-unit .playPauseContainer .playArrow {\n  width: 100%;\n  height: 100%;\n  border: none;\n  position: absolute;\n  left: 0; \n  top: 0;\n  z-index: 1;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: 100px;\n  background-image: url(" + escape(require("./play_white.png")) + ")\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/Components/PlayPause/PlayPause.css
// module id = 173
// module chunks = 6